import { useState } from 'react';
import axiosInstance from '../../api/axiosInstance';
import PageContainer from '../../pageLayout/PageContainer';
import logo_horizontal from '../../img/teachernote-logo/teachernote-logo-horizontal.png';
import { AuthBox, AuthLayout1 } from '../registerModal/Register2Style';
import { AuthCardContainer } from '../../components/AuthCardContainer';
import Input from '../../components/StyledInput';
import MainButton from '../../components/MainButton';
import { AuthAlertText } from '../../components/AuthPageStyle';
import { ForgotPasswordHelmetContent } from '../../components/HelmetContent';

const ForgotPasswordPage = () => {
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [clickTimestamps, setClickTimestamps] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    //횟수제한
    const now = Date.now();
    const oneMinuteAgo = now - 60000;
    const recentClicks = clickTimestamps.filter((ts) => ts > oneMinuteAgo);
    if (recentClicks.length >= 5) {
      setMessage('너무 많은 요청입니다. 잠시 후 다시 시도해 주세요.');
      setIsSuccess(false);
      return;
    }
    setClickTimestamps([...recentClicks, now]);

    setMessage('');
    setIsLoading(true);
    setIsSuccess(false);

    try {
      const res = await axiosInstance.post('/request-password-reset', {
        userId,
        email,
      });
      //   const res = await axios.post(
      //     'https://teachernote.me/api/request-password-reset',
      //     { userId, email },
      //   );
      setIsSuccess(true);
      setMessage('해당 이메일로 비밀번호 재설정 링크를 보냈습니다.');
    } catch (error) {
      setIsSuccess(false);
      setMessage(
        error?.response?.data?.message ||
          '일치하는 사용자 정보를 찾을 수 없습니다.',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PageContainer>
      <ForgotPasswordHelmetContent />
      <AuthBox>
        <AuthLayout1>
          <div>
            <img
              src={logo_horizontal}
              style={{ width: '300px' }}
              alt="티처노트 로고 - 가로형"
            />
          </div>
          비밀번호 재설정을 도와드릴게요!
        </AuthLayout1>
        <AuthCardContainer className="forgot-password-page">
          {' '}
          <form onSubmit={handleSubmit}>
            <Input
              type="text"
              placeholder="아이디"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
            />
            <br />
            <Input
              type="email"
              placeholder="가입한 이메일 주소"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <MainButton type="submit">재설정 링크 보내기</MainButton>
          </form>
          {isLoading && (
            <AuthAlertText style={{ color: '#555' }}>
              처리 중입니다. 잠시만 기다려 주세요...
            </AuthAlertText>
          )}
          {!isLoading && message && (
            <AuthAlertText style={{ color: isSuccess ? '#2e8b57' : '#d9534f' }}>
              {message}
            </AuthAlertText>
          )}
        </AuthCardContainer>
      </AuthBox>
    </PageContainer>
  );
};

export default ForgotPasswordPage;
